<template>
  <div class="container-theme">
    <div ref="articleEle" class="content" :style="style">
      <p class="date">{{ myDate }}</p>
      <h1 class="title">{{ title }}</h1>
      <article class="article" v-html="content"></article>
    </div>
    <div class="cut-line"></div>
    <div class="footer-btn" v-if="show">
      <div @click="handlerChangeThemeState">
        <span class="btn-text">{{ isOpen ? "收起主题" : "查看主题" }}</span>
        <img
          src="@/assets/com_icon_dropdown_blue.png"
          alt="down-btn"
          class="btn-icon"
          :class="{ 'btn-icon-trans': isOpen }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate, verifyDate } from '@/common/js/utils';
import {
  ref, onMounted, watch, nextTick
} from '@vue/composition-api';

export default {
  props: {
    date: {
      validator(val) {
        return verifyDate(val);
      },
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    isOpen: {
      // 是否展开打卡主题
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    // 将日期转换为相应格式
    const myDate = ref('');
    myDate.value = formatDate(props.date);

    // 日期改变时再调用方法格式化日期
    watch(() => props.date, (val) => {
      if (!val) {
        return;
      }

      myDate.value = formatDate(val);
    });

    const articleEle = ref(null);
    // 是否显示收起/展开按钮
    const show = ref(false);
    const style = ref('');
    /**
     * @description 设置文章+标题+日期整体模块的高度
     */
    const setArticleHeight = () => {
      // 先移除style样式，再去获取真实高度
      style.value = '';

      nextTick(() => {
        // 高度大于240，则显示收起/展开按钮
        const height = articleEle.value.scrollHeight;
        if (height <= 240) {
          show.value = false;
          return;
        }

        show.value = true;
        if (!props.isOpen) {
        // 不展开则设置固定高度240px
          style.value = 'overflow: hidden; height: 240px;';
        } else {
          style.value = 'overflow: hidden; height: auto;';
        }
      });
    };

    onMounted(() => {
      setArticleHeight();
    });

    // 文章内容或文章状态改变时，重新设置其高度
    watch([() => props.content, () => props.isOpen], () => {
      setArticleHeight();
    });

    /**
     * @description 收起/展开主题
     */
    const handlerChangeThemeState = () => {
      emit('update:isOpen', !props.isOpen);
    };

    return {
      myDate,
      articleEle,
      show,
      style,
      handlerChangeThemeState
    };
  }
};
</script>

<style lang="stylus" scoped>
.container-theme {
  width: 100%;
  font-size: 14px;
  background: #fff;

  .content {
    padding: 10px 16px;

    .date {
      margin: 0;
      padding: 0;
      color: #999;
    }

    .title {
      margin: 16px 0;
      padding: 0;
      font-size: 22px;
      line-height: 1.5em;
      color: #191919;
      font-weight: 500;
    }

    .article {
      line-height: 1.5em;
      color: #191919;
      word-break: break-all;

      /deep/ p {
        font-size: 14px;
        line-height: 22px;
        color: #191919;
      }

      /deep/ img {
        margin: 5px auto;
        width: 100%;
      }
    }
  }

  .cut-line {
    width: 100%;
    height: 0.5px;
    background: #E7E7E7;
  }

  .footer-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 48px;
    background: #fff;
  }

  .btn-text {
    color: #14B0FF;
  }

  .btn-icon {
    width: 12px;
    height: 12px;
  }

  .btn-icon-trans {
    transform: rotate(180deg);
  }
}
</style>
